import script from "./VideosCriarEditar.vue?vue&type=script&setup=true&lang=js"
export * from "./VideosCriarEditar.vue?vue&type=script&setup=true&lang=js"

import "./VideosCriarEditar.vue?vue&type=style&index=0&id=5acd5726&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5acd5726"]])

export default __exports__